import { getOutcomeText } from 'components/core/task/outcome/getOutcomeText'
import { Outcome } from 'components/core/task/outcome/Outcome'
import { OutcomeBanner } from 'components/core/task/outcome/outcomeBanner'
import { OutcomeIcon } from 'components/core/task/outcome/OutcomeIcon'

export { getOutcomeText, Outcome, OutcomeBanner, OutcomeIcon }
